import L from 'leaflet';
import 'leaflet-control-geocoder';
import 'leaflet.locatecontrol';
L.noConflict()


module.exports = L
